import { handlePostApi } from '@/api/crud';
import {
  branchAccessEndpoints,
  menuApiEndpoints,
  roleApiEndpoints,
  subscribeApiEndpoints,
  versionApiEndpoints,
} from '@/api/endpoints';
import { usePostApi } from '@/apiError/apiCreate';
import { ShowAllData } from '@/apiError/apiShow';
import CustomTree from '@/components/admin/tree/Tree';
import { useFetch } from '@/hooks';
import { optionSearchFunction } from '@/utils/common';
import GlobalDivider from '@/utils/divider/GlobalDivider';
import { rules } from '@/utils/validation/FormValidation';
import { PlusCircleOutlined, SearchOutlined } from '@ant-design/icons';
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Layout,
  Modal,
  Row,
  Select,
  Space,
} from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { useEffect, useState, version } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCreateVersions } from './hooks/useVersions';

const { Content } = Layout;

const CreateVerison = ({ refetch }) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const showModal = () => {
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
  };

  const { mutateAsync: createVersion } = useCreateVersions();

  function handleSubmit(value) {
    createVersion(value, {
      onSuccess: () => {
        setOpen(false);
      },
    });
    refetch();
  }

  useEffect(() => {
    // const fetchMenuList = async () => {
    //   try {
    //     const { data } = await menuApiEndpoints.retrieveList();
    //     const initialPermissions = data.data.menus?.map((menu) => ({
    //       key: menu.referenceId,
    //       title: menu.Name,
    //       create: false,
    //       view: false,
    //       edit: false,
    //       delete: false,
    //       full: false,
    //       children: menu.subMenus
    //         ? generateSubMenuPermissions(menu.subMenus)
    //         : [],
    //     }));
    //     setPermissions(initialPermissions || []);
    //     setFilteredPermissions(initialPermissions || []);
    //   } catch (error) {
    //     console.error('Error fetching menu list:', error);
    //   }
    // };
    // fetchMenuList();
  }, []);

  return (
    <>
      <Button
        className="header-add centered"
        size="medium"
        type="primary"
        onClick={showModal}
      >
        <PlusCircleOutlined />
        Create
      </Button>
      <Modal
        open={open}
        onCancel={closeModal}
        title="Create Version"
        footer={null}
      >
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="versionName"
                label="Version Name"
                rules={rules.required}
              >
                <Input placeholder="Verison Name" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="price" label="Price" rules={rules.required}>
                <Input placeholder="Price" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={24}>
              <Form.Item name="description" label="Description">
                <TextArea placeholder="Description" />
              </Form.Item>
            </Col>
          </Row>

          <div style={{ textAlign: 'right', marginTop: '12px' }}>
            <Space size="large">
              <Button
                htmlType="submit"
                className="submit-button"
                type="primary"
              >
                Create
              </Button>
              <Button className="cancel-button" onClick={closeModal}>
                Cancel
              </Button>
            </Space>
          </div>
        </Form>
      </Modal>
    </>
  );
};

export default CreateVerison;
